import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import parsePostContent from '../../common/helpers/parsePostContent';
/** System post for "player surrendered". Type: arenaBattleSurrender. */
export default class ArenaBattleSurrenderPost extends Component {
  view() {
    const data = parsePostContent(this.attrs.post.content());
    if (!data) return null;
    return m("div", {
      className: "ArenaFinalPost ArenaFinalPost--surrender EventPost"
    }, m("div", {
      className: "ArenaFinalPost-icon"
    }, m("i", {
      className: "fas fa-trophy"
    })), m("div", {
      className: "ArenaFinalPost-body"
    }, m("div", {
      className: "ArenaFinalPost-title"
    }, app.translator.trans('forumaker-arena.forum.battle_surrender.title', {
      name: m("strong", null, data.winnerName)
    })), m("div", {
      className: "ArenaFinalPost-subtitle"
    }, app.translator.trans('forumaker-arena.forum.battle_surrender.subtitle', {
      name: data.surrenderedByName
    }))));
  }
}
flarum.reg.add('forumaker-arena', 'forum/components/ArenaBattleSurrenderPost', ArenaBattleSurrenderPost);